import { ReturnedAction } from '../reduxTypes';
import { CopyData } from '../../types';

export const setCopyData = (value: CopyData): ReturnedAction => ({
  type: 'SET_COPY_DATA',
  value
});
